import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface FormSubmissionRequest<TData = unknown, TContext = unknown> {
  formIdentifier: string;
  caseId?: string | null;
  documentId?: string | null;
  source: string;
  data: TData;
  context?: TContext;
}

export interface FormSubmissionResponse {
  state: string;
  formIdentifier: string;
  acceptedAt: string;
}

export interface FormRenderingRequest<TData = unknown> {
  formIdentifier: string;
  data: TData;
}

export interface FormRenderingResponse {
  fileName: string;
  contentType: string;
  content: string;
}

@Injectable({
  providedIn: 'root'
})
export class FormSubmissionService {

  constructor(private readonly httpClient: HttpClient) {
  }

  submit<TData, TContext>(request: FormSubmissionRequest<TData, TContext>): Observable<FormSubmissionResponse> {
    return this.httpClient.post<FormSubmissionResponse>(`${environment.backendUrl}/api/form-submissions`, request);
  }

  getSavedData<TData>(caseId: string, documentId: string, tenant: string): Observable<TData | null> {
    const params = new HttpParams()
      .set('caseId', caseId)
      .set('documentId', documentId)
      .set('tenant', tenant);
    return this.httpClient.get<TData | null>(`${environment.backendUrl}/api/form-submissions/saved`, { params });
  }

  renderPreview<TData>(request: FormRenderingRequest<TData>): Observable<FormRenderingResponse> {
    return this.httpClient.post<FormRenderingResponse>(`${environment.backendUrl}/api/form-submissions/render-preview`, request);
  }
}
